import React from 'react'

import { R1Data } from 'src/store/ducks/reports/types'

import { Row, Col } from 'antd'
import { Empty, Text } from 'src/components/Ant'
import { stringify } from 'src/core/hooks/use-translation'
import { WrapSectionReceipts, WrapSectionReceipt } from './styles'
import { WarpEmpty, WarpCenter } from '../../../../styles'

function SectionReceipts({
  dataSource
}: {
  dataSource: Pick<R1Data, 'image_href' & 'image_number'>[]
}) {
  return (
    <WrapSectionReceipts>
      <Row>
        <Col span={24}>
          {dataSource && dataSource.length <= 0 ? (
            <WarpEmpty>
              <Empty />
            </WarpEmpty>
          ) : (
            <div id="content">
              {dataSource.map((item: any, index: number) => (
                <div key={index} id="block">
                  <Row>
                    <Col span={24}>
                      <WarpCenter>
                        <Text>#{item.image_number}</Text>
                      </WarpCenter>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <WarpCenter>
                        <WrapSectionReceipt
                          title={stringify(
                            'web.report.1.receipts.image-number',
                            {
                              number: item.image_number
                            }
                          )}
                          alt="web.report.1.receipts.alt"
                          src={item.image_href}
                        />
                      </WarpCenter>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          )}
        </Col>
      </Row>
    </WrapSectionReceipts>
  )
}
export default SectionReceipts
